import { Modal, TitleBar } from '@shopify/app-bridge-react';

import { connect } from 'react-redux';
import { generateBarcodes } from '../../redux/actions/barcodes';

const ConfirmGenerationDialog = ({ shopify, shopUrl, payload, selectedVariantList, barcodes, generateImages, setGenerating }) => {
  return(
    <Modal id="generate-modal" variant="large">
      <div className="modal-body">
        <p style={{ 'color': '#8e1f0b' }}>
          Generate barcode images for selected products/variations. Existing barcode images will be deleted and replaced. This action can't be undone.
        </p>
      </div>
      <TitleBar title="Generate Selected Barcodes">
        <button onClick={() => generate(shopUrl, payload, selectedVariantList, barcodes.status, generateImages, setGenerating)} variant="primary">Generate Barcode Images</button>
        <button onClick={() => shopify.modal.hide('generate-modal')}>Cancel</button>
      </TitleBar>
    </Modal>
  )
}

const generate = (shopUrl, payload, selectedVariantList, status, generateImages, setGenerating) => {
  if(status !== "requesting") {
    generateImages(shopUrl, payload, selectedVariantList);
  }

  setGenerating(true);
  shopify.modal.hide('generate-modal')
}

const mapStateToProps = state => ({
  selectedVariantList: state.products.selectedVariantList,
  barcodes: state.barcodes,
});

const mapDispatchToProps = (dispatch) => ({
  generateImages: (shopUrl, payload, barcodes) => dispatch(generateBarcodes(shopUrl, payload, barcodes)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmGenerationDialog);